import { ErrorFieldElement } from "./types";

const isErrorFieldElement = (item: {
   fieldId: string;
   element: Element | null;
}): item is ErrorFieldElement => {
   return item.element !== null;
};

export const findFirstErrorFieldIdByDomPosition = (
   validationErrorsByFieldId: Record<string, any>,
) => {
   const errorFieldIds = Object.keys(validationErrorsByFieldId || {}).filter(Boolean);

   const errorFieldElements = errorFieldIds
      .map((fieldId) => ({
         fieldId,
         element: document.querySelector(`[data-field-id="${fieldId}"]`),
      }))
      .filter(isErrorFieldElement);

   if (errorFieldElements.length === 0) {
      return errorFieldIds[0];
   }

   const sortedByTop = errorFieldElements.sort((firstItem, secondItem) => {
      const firstTop = firstItem.element.getBoundingClientRect().top;
      const secondTop = secondItem.element.getBoundingClientRect().top;
      return firstTop - secondTop;
   });

   return sortedByTop[0].fieldId;
};

export const scrollToFieldById = (fieldId: string) => {
   const element = document.querySelector(`[data-field-id="${fieldId}"]`);
   if (element?.scrollIntoView) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
   }
};
